// extracted by mini-css-extract-plugin
export default {"clear":"styles_clear__81A1g"};